export type Denom = string;

export namespace Denom {
  export const LUNA = 'uluna';
  export const CNY = 'ucny';
  export const EUR = 'ueur';
  export const GBP = 'ugbp';
  export const JPY = 'ujpy';
  export const KRW = 'ukrw';
  export const MNT = 'umnt';
  export const SDR = 'usdr';
  export const USD = 'uusd';
}
